import { formatNumberMix } from '@/utils'
export default {
  data() {
    return {
      defaultOptions: [
        {
          label: this.$t('merits-board::成交额'),
          value: 1
        },
        {
          label: this.$t('merits-board::目标达成'),
          value: 2
        }
      ]
    }
  },
  methods: {
    setTargetOption(data = {}) {
      return {
        type: 'ring',
        ref: 'attributeEchart',
        height: '150px',
        chart: {
          legend: {
            show: false
          },
          tooltip: {
            show: false
          },
          series: [
            {
              type: 'pie',
              radius: ['50%', '70%'],
              label: {
                show: true,
                position: 'center',
                color: '#1B223C',
                fontWeight: 'bold',
                fontSize: '16px'
              },
              itemStyle: {
                normal: {
                  labelLine: {
                    show: false
                  }
                }
              },
              emphasis: {
                scale: false
              },
              data: [
                {
                  value: (data.value || 0),
                  name: (data.value || 0) + '%',
                  itemStyle: {
                    normal: { color: data.color || '#0560fd' },
                    emphasis: { color: data.color || '#0560fd' }
                  }
                },
                {
                  value: 100 - (data.value || 0),
                  name: (data.value || 0) + '%',
                  itemStyle: {
                    normal: { color: data.emptyColor || '#EDF1FC' },
                    emphasis: { color: data.emptyColor || '#EDF1FC' }
                  }
                }
              ]
            }
          ]
        }
      }
    },
    setTeamConfig(data = [], type) {
      return {
        title: this.$t('merits-board::团队排行榜'),
        ref: 'teamTable',
        height: '325px',
        cancelShadow: true,
        tableData: data,
        radio: type,
        radioOptions: this.defaultOptions
      }
    },
    setCampConfig(data = [], type) {
      return {
        title: this.$t('merits-board::优化师排行榜'),
        ref: 'teamTable',
        height: '325px',
        cancelShadow: true,
        tableData: data,
        radio: type,
        radioOptions: this.defaultOptions
      }
    },
    setShopConfig(data = [], type) {
      return {
        title: this.$t('merits-board::店铺成交额排行榜'),
        ref: 'teamTable',
        height: '325px',
        cancelShadow: true,
        tableData: data,
      }
    },
    setDataConfig(data = [], doubleShaft, measure) {
      const measure1 = measure[0] && this.tags.find(i => i.value === measure[0]).label
      const measure2 = measure[1] && this.tags.find(i => i.value === measure[1]).label
      return {
        type: 'line',
        title: this.$t('merits-board::绩效趋势'),
        ref: 'lineChart',
        height: '350px',
        doubleShaft: doubleShaft,
        chart: {
          xAxis: {
            data: data.map(item => item.dt)
          },
          yAxis: [
            {
              type: 'value',
              name: measure1,
              splitLine: {
                lineStyle: {
                  color: '#999999',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                color: '#999999'
              }
            },
            {
              type: 'value',
              name: measure2,
              position: 'right',
              splitLine: {
                show: false
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999'
              }
            }
          ],
          series: [
            {
              type: 'line',
              name: measure1,
              data: data.map(item => item.value1)
            },
            {
              type: 'line',
              name: measure2,
              yAxisIndex: 1,
              data: data.map(item => item.value2)
            }
          ]
        }
      }
    }
  }
}
